module.exports = __webpack_public_path__ + "img/simple.d1d92f56.png";